// extracted by mini-css-extract-plugin
module.exports = {"pageButton":"Pagination_pageButton__DFhus","value":"Pagination_value__wJkYs"};